var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"400","value":_vm.cmn_store.is_loading}},[_c('v-card',{attrs:{"color":"primary darken-2","dark":""}},[_c('v-card-text',[_vm._v(" しばらくお待ちください...... "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }